import {
  type Auth0PluginOptions,
  type Auth0VueClientOptions,
  initializeAuth0
} from '@gat-ship/lib/auth'
import type { Plugin } from 'vue'

const clientOptions: Auth0VueClientOptions = {
  domain: 'gatship.eu.auth0.com',
  clientId: 'o0i6mRj8d9nmr3LMrf2UzIS3Xa47kpXp',
  authorizationParams: {
    audience: 'https://gatship.com/cloud/core-api',
    scope: 'openid profile email',
    redirect_uri: `${window.location.origin}/oauth2-callback`
  },
  useRefreshTokens: true
}

const pluginOptions: Auth0PluginOptions = {
  skipRedirectCallback: true
}

const auth0Plugin: Plugin = initializeAuth0(clientOptions, pluginOptions)
export default auth0Plugin
